import { render, staticRenderFns } from "./CompaniesTableRow.vue?vue&type=template&id=79c97958&"
import script from "./CompaniesTableRow.vue?vue&type=script&lang=ts&"
export * from "./CompaniesTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./CompaniesTableRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports